var MuiCard = {
    /* put your new default props here */
    square: false,
};
export default MuiCard;
//# sourceMappingURL=MuiCard.js.map